/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ScanIcon extends BaseIcon {
  getChildren = () => [ <g fill={this.getColor()}>
    <g>
      <path d="M2.03,8C2.27,4.81,4.81,2.27,8,2.03v-1C4.26,1.27,1.27,4.26,1.03,8H2.03z"/>
      <path d="M14.97,9c-0.24,3.19-2.78,5.73-5.97,5.97v1c3.74-0.25,6.73-3.23,6.97-6.97H14.97z"/>
      <path d="M8,14.97C4.81,14.73,2.27,12.19,2.03,9h-1c0.25,3.74,3.23,6.73,6.97,6.97V14.97z"/>
    </g>
    <g>
      <path d="M4.05,8C4.28,5.92,5.92,4.28,8,4.05V3.03C5.36,3.26,3.26,5.36,3.03,8H4.05z"/>
      <path d="M8,12.95C5.92,12.72,4.28,11.08,4.05,9H3.03c0.24,2.64,2.34,4.74,4.97,4.97V12.95z"/>
      <path d="M12.95,9c-0.23,2.08-1.87,3.72-3.95,3.95v1.03c2.64-0.24,4.74-2.34,4.97-4.97H12.95z"/>
    </g>
    <g>
      <path d="M6.05,8C6.25,7.02,7.02,6.25,8,6.05v-1C6.47,5.27,5.27,6.47,5.05,8H6.05z"/>
      <path d="M8,10.95C7.02,10.75,6.25,9.98,6.05,9h-1c0.22,1.53,1.42,2.73,2.95,2.95V10.95z"/>
      <path d="M10.95,9c-0.2,0.98-0.97,1.75-1.95,1.95v1c1.53-0.22,2.73-1.42,2.95-2.95H10.95z"/>
    </g>
    <path d="M9,8h6.97C15.73,4.26,12.74,1.27,9,1.03V8z"/>
  </g> ]
  getViewBox = () => '0 0 16 16'
}
